<template>
    <div class="footer_new">
        <div class="footer_container">
            <div>
                <img :src="require('@/assets/images/logo_copyright.png')" alt="">
            </div>
            <div class="media_links">
                <MediaLinks></MediaLinks>
            </div>
            <div class="copyright">
                <div>
                    Copyright © 2025 All Rights Reserved by
                    <span class="highlight">Contrimetric</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MediaLinks from "@/components/mediaLinks/index.vue"

export default {
    components: {
        MediaLinks
    },
    data() {
        return {

        }
    }
}
</script>

<style lang='scss'>
.footer_new {
    width: 100%;
    background-color: black;

    .footer_container {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: self-end;
        padding: 50px 0;
    }

    .media_links {
        transform: translateY(16px);
    }

    .copyright {
        color: white;

        .highlight {
            color: #73ffff;
        }
    }
}
</style>